module.exports = __webpack_public_path__ + "img/1.06e7255d.png";